import { Button, Modal, Popover } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import DelCaseModal from '../../../../Home/DelCaseModal'
import Api from '../../api'
import AppealModal from './AppealModal'
import Style from './style.module.less'

@inject('store')
@observer
class Footer extends Component {
  constructor() {
    super()
    this.state = {
      delVisible: false
    }
  }

  canotEdit() {
    Modal.info({
      title: '提示',
      content: '该案例已被举报，正在审核处理中，暂时无法发布或删除案例。',
      okText: '知道了',
      onOk() {}
    })
  }

  async publicHandler() {
    const form_init = this.props.store.form_init
    if (form_init.report) {
      this.canotEdit()
    } else {
      if (!this.props.id) {
        const isConsult = await this._queryConsultCountList()
        if (isConsult == 1) {
          this.setState({
            delVisible: true
          })
          return
        }
      }
      this.props.handleSubmit('save')
    }
  }

  confirm() {
    const form_init = this.props.store.form_init
    if (form_init.report) {
      this.canotEdit()
    } else {
      this.props.store.deleteCase(
        this.props.isDraft ? this.props.draftId : this.props.id,
        this.props.isDraft
      )
    }
  }

  saveDraft = () => {
    this.props.handleSubmit('draft')
  }

  _queryConsultCountList = async () => {
    const { success, data } = await Api.getConsultCount()
    if (success) {
      return data
    }
  }

  render() {
    const { id, isDraft, store } = this.props
    const { complainSuccess, case_detail } = store
    const unCertified =
      [0, 1, 3].includes(
        case_detail?.merchant_proof?.appeal_proof?.proof?.appeal_status
      ) && case_detail?.status === 3

    const showDraftBtn = !id || isDraft

    let showDelBtn = true
    let delTip = '确定删除草稿箱中的该案例吗？'

    if (isDraft) {
      delTip = '确定删除草稿箱中的该案例吗？'
    } else if (case_detail.is_never_sold) {
      // 从未上架
      delTip = '确定删除该案例？'
    } else if (case_detail.is_sold_out) {
      // 已下架
      delTip = '该案例已下架，删除后若您再次发布，则需要重新审核，确定删除吗？'
    } else {
      // 已上架  TODO 从未上架
      delTip = '该案例已上架，删除后顾客将无法访问该案例，确定删除吗？'
    }

    if (!id && !isDraft) {
      showDelBtn = false
    }
    return (
      <div className={Style.footer}>
        <AppealModal id={this.props.id} />
        <DelCaseModal
          visible={this.state.delVisible}
          onCancel={() => {
            this.setState({
              delVisible: false
            })
          }}
        />
        <Button
          type="primary"
          onClick={() => this.publicHandler()}
          style={{ width: '120px', height: '40px' }}
        >
          发布案例
        </Button>
        {unCertified &&
          !complainSuccess && (
            // xin_tian屏蔽
            <Button
              type="default"
              onClick={() => store.setAuditBoxVisible(true)}
              style={{ width: '120px', height: '40px', marginLeft: '8px' }}
            >
              发起申诉
            </Button>
          )}
        {showDraftBtn && (
          <Button
            type="default"
            onClick={this.saveDraft}
            style={{ width: '120px', height: '40px', marginLeft: '8px' }}
          >
            存为草稿
          </Button>
        )}
        {showDelBtn && (
          <Popover
            placement="top"
            content={
              <div className={Style.popStyle}>
                <div className={Style.popTip}>{delTip}</div>
                <div className={Style.popFooter}>
                  <Button
                    type="primary"
                    className={Style.popBtn}
                    onClick={() => this.confirm()}
                  >
                    删除
                  </Button>
                </div>
              </div>
            }
          >
            <span className={Style.delCaseBtn}>删除案例</span>
          </Popover>
        )}
      </div>
    )
  }
}

export default Footer
